import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ palette,variables }) => ({
  orderDetailCardItemWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: variables?.spacingB,
    width:'100%'
  },
  orderDetailCardItemCount: {
    width:'24px',
    flexShrink: 0,
    textAlign: 'center'
  },

  orderDetailCardItemContent: {
    display:'flex',
    flexDirection: 'column',
    color: palette.jet?.contentSubdued
  },
  orderDetailCardItemBadge: {
    display: 'flex',
    marginTop: variables?.spacingA
  }

}));

export default styles;
